import isValidDate from "./isValidDate";
import parseDate from "./parseDate";

export default function tryParseDate(value: unknown): Date | null {
  const date = parseDate(value);

  if (isValidDate(date)) {
    return date;
  }

  return null;
}
